import { Button } from "@component/button";
import { Link } from "react-router-dom";
import { ShapesIcon as HomeIcon } from "lucide-react";
import { getCookie } from "@util/cookie";
import BasicLayout from "@container/layout/basic";

export default function UnAuthorizedPage() {
    const token = getCookie('authToken');
    return (
        <BasicLayout>
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-6">
                <div className="text-center max-w-lg">
                    <div className="mb-8">
                        <div className="relative mx-auto w-48 h-48">
                            <div className="absolute inset-0 bg-blue-600/10 rounded-full animate-pulse"></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <span className="text-blue-600 text-6xl font-bold">401</span>
                            </div>
                        </div>
                    </div>

                    <h1 className="text-3xl font-bold mb-2">Unauthorized.</h1>
                    <p className="text-gray-500 dark:text-gray-400 mb-8">
                        You don't have permission to access this page.<br />Please make sure you're logged in with the correct credentials.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Button
                            asChild
                            className="bg-blue-600 hover:bg-blue-800 flex items-center gap-2"
                        >
                            {token && (
                                <Link to="/dashboard">
                                    <HomeIcon className="h-4 w-4" />
                                    Back to Dashboard
                                </Link>
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </BasicLayout>
    );
}
